<template>
  <div v-if="list.length>0" class="mylistdo" style="">
    <el-row style="padding-bottom:5px;" :key="i1" v-for="(obj,i1) in list">
      <div style="display: inline-block;vertical-align: top;">
        <template>
          <slot :data="obj" :rowidx="i1"></slot>
        </template>
      </div>
      <div style="display: inline-block;vertical-align: top;margin-left:10px; ">
        <el-button icon="el-icon-plus" type="primary" size="mini" circle @click="addItem(i1,obj)"></el-button>
        <el-button icon="el-icon-minus" type="danger" size="mini" circle @click="delItem(i1,obj)"></el-button>
      </div>
    </el-row>
  </div>
  <div v-else="list.length==0"  class="mylistdo" style="">
    <el-button icon="el-icon-plus" type="primary" size="mini" circle @click="addItem(0,{})"></el-button>
    <el-button icon="el-icon-minus" type="danger" size="mini" circle @click="delItem(0,{})"></el-button>
  </div>
</template>
<script>
  import Vue from "vue";
  import $ from 'jquery';
  export default {
    name: 'MyListDo',
    props: {
      items: {
        type: [Array],
        default(){
          return [];
        }
      },
      def: {
        type: [Object],
        default(){
            return {};
        }
      },
      onAdd: {
        type: [Function],
        default(){
          return $.extend(true,{},this.def);
        }
      },
      onDel: {
        type: [Function],
        default(){
          return true;
        }
      }
    },//此处col为对象,
    data(){
      return {
        list: this.items
      }
    },
    watch: {
      items(){
        this.list = this.items;
      }
    },
    methods: {
      addItem: function (idx, cur) {
        var data = this.onAdd(idx, cur);
        if (data != false) {
          this.list.splice(idx + 1, 0, data);
        }
      },
      delItem: function (idx, cur) {
        var data = this.onDel(idx, cur);
        if (data != false) {
          this.list.splice(idx, 1);
        }
      }
    }
  }
</script>
<style>
   .el-form-item .mylistdo .el-form-item{
    margin-bottom:22px;
  }
</style>



// WEBPACK FOOTER //
// src/components/MyListDo.vue